import axios from 'axios';
import {SERVER_URL} from '../../constants/api';
import {showErrorToast} from '../../components/common/toasts/utils';
import {getLocalSelectedOffice} from "../localStorage/office";

const handleApiError = (error, onError, {silent} = {}) => {
    console.error(error);
    !silent && showErrorToast(['Oops something went wrong! Try again later.']);
    onError && onError(error);
}

const handleApiResult = (result, onSuccess) => {
    if (!result) {
        throw new Error('Invalid response');
    }
    onSuccess && onSuccess(result.data);
}

const buildUrl = (resource) => `${SERVER_URL}${resource}`;

function addAuthHeaders() {
    const token = sessionStorage.getItem('token')
    return token ? {Authorization: `Bearer ${token}`} : {}
}

const buildConfig = () => ({
    withCredentials: true,
    headers: addAuthHeaders(),
    params: {
        office: getLocalSelectedOffice()
    }
});

export const apiGet = (resource, onSuccess, onError, options) =>
    axios.get(buildUrl(resource), buildConfig())
        .then(result => handleApiResult(result, onSuccess))
        .catch(error => handleApiError(error, onError, options));

export const apiPost = (resource, data, onSuccess, onError, token) =>
    axios.post(buildUrl(resource), data, buildConfig(token))
        .then(result => handleApiResult(result, onSuccess))
        .catch(error => handleApiError(error, onError));

export const apiDelete = (resource, onSuccess, onError, token) =>
    axios.delete(buildUrl(resource), buildConfig(token))
        .then(result => handleApiResult(result, onSuccess))
        .catch(error => handleApiError(error, onError));

export const apiPut = (resource, data, onSuccess, onError, token) =>
    axios.put(buildUrl(resource), data, buildConfig(token))
        .then(result => handleApiResult(result, onSuccess))
        .catch(error => handleApiError(error, onError));
